// The header's "which order and why" line (2026-10-29,
// docs/decisions/2026-10-29-settled-order.md). With several candidate orders
// the header says which one the contact uses and why: "from the item named on
// 10/27 (hub, bearing)", "chosen by <person>", "newest, to be confirmed".
// orderChoice is the latest suggestion's modelMeta.orderChoice
// (server/src/ai/settled-order.js); the person's display name shows here only,
// never in the call log. Pure, no React.

const CLUE_NOUN = {
  named: 'order or part number',
  order_number: 'order number',
  item: 'item',
  address: 'shipping address',
  date: 'order date',
  carrier: 'carrier',
}

function shortDay(v) {
  const t = Date.parse(String(v ?? ''))
  if (!Number.isFinite(t)) return null
  return new Date(t).toLocaleDateString('en-US', { timeZone: 'America/New_York', month: '2-digit', day: '2-digit' })
}

const clueDetail = (why) => {
  const m = /^[a-z]+: (.+)$/.exec(String(why ?? ''))
  return m ? m[1] : null
}

// One settled order's reason: "from the item named on 10/27 (hub)",
// "chosen by Pat Lee (reply sent 10/27)".
export function settledOrderText(settled) {
  if (!settled) return null
  const day = shortDay(settled.at)
  if (settled.by === 'person') {
    const what = settled.action === 'processed' ? 'step processed' : 'reply sent'
    return `chosen by ${settled.person || 'an agent'} (${what}${day ? ` ${day}` : ''})`
  }
  const noun = CLUE_NOUN[settled.clue] ?? 'clue'
  const detail = settled.clue === 'item' || settled.clue === 'named' ? clueDetail(settled.why) : null
  return `from the ${noun} named${day ? ` on ${day}` : ''}${detail ? ` (${detail})` : ''}`
}

// Why the contact uses erpOrderId, or null when nothing can be said (one
// candidate, or a choice saved for another order).
export function orderChoiceText({ orderChoice = null, erpOrderId = null, erpOrderIdOverride = null, erpOrderIdOverrideSetBy = null } = {}) {
  if (!erpOrderId) return null
  if (erpOrderIdOverride && String(erpOrderIdOverride) === String(erpOrderId)) return `chosen by ${erpOrderIdOverrideSetBy || 'an agent'}`
  if (!orderChoice || String(orderChoice.erpOrderId ?? '') !== String(erpOrderId)) return null
  switch (orderChoice.how) {
    case 'clue':
      return settledOrderText(orderChoice.settled) ?? `from the message (${orderChoice.why})`
    case 'settled':
      return settledOrderText(orderChoice.settled) ?? String(orderChoice.why ?? '')
    case 'switched': {
      const why = orderChoice.settled?.erpOrderId === orderChoice.erpOrderId ? settledOrderText(orderChoice.settled) : `from the message (${orderChoice.why})`
      return `${why}, not the conversation's ${orderChoice.previous}; to be confirmed`
    }
    default:
      return `${orderChoice.why || 'newest'}, to be confirmed`
  }
}
